<template>
  <v-app id="Gbmt1">
    <v-main>
      <v-container fluid>    
        <v-row no-gutters>
          <v-col cols="1" class="px-2 pt-4 pb-1">
              <date_picker label="Date from"                                 
                            :date="hsabFromDate"
                            :startDate="hsabFromDate"
                            field="hsabFromDate" 
                            hint="Only enter a date if applicable" 
                            icon="mdi-calendar-month-outline"
                            :manual="true" 
                            @updateData="updateData"/> 
          </v-col>
          <v-col cols="1" class="pa-2 pt-4">
              <date_picker label="Date until"                                 
                            :date="hsabUntilDate"
                            :startDate="hsabFromDate"
                            field="hsabUntilDate" 
                            hint="Only enter a date if applicable" 
                            icon="mdi-calendar-month-outline"
                            :manual="true" 
                            @updateData="updateData"/>                                      
          </v-col>
          <v-col cols="1" class="px-2 pt-4 pb-1 ml-4">
            <v-btn class="primary ma-0 pr-4" :loading="loading" small @click="getData"><v-icon medium class="mr-1">mdi-database-outline</v-icon>Get data</v-btn>
          </v-col>           
      </v-row>
      <v-card flat>
        <v-card-title class="justify-center">Clearings overview (EUR)</v-card-title>
        <v-divider class="mb-2"/>
        <v-simple-table dense v-if="clearings.length > 0">
            <thead>
                <tr>
                    <th>PAY.nl Clearing ID</th>
                    <th>ABN-AMRO bookdate</th>
                    <th>Transaction Id</th>
                    <th style="text-align: right;">Total Clearing</th>
                    <th style="text-align: right;">Bank mutation</th>
                    <th style="text-align: right;">Difference</th>
                </tr>
            </thead>
            <tbody v-for="(clearing, i) in clearings" :key="i">
                <tr :class="{'color': i%2!==0}" @click="openDetail(clearing.pncl_id, clearing.amount)">
                    <td style="width: 300px;">{{ clearing.pncl_id }}</td>
                    <td>{{ clearing.bookdate }}</td>
                    <td>{{ clearing.transactionId }}</td>
                    <td align="right">{{ formatAmount(clearing.amount) }}</td>
                    <td align="right">{{ formatAmount(clearing.bankmutation_amount) }}</td>
                    <td align="right">{{ formatAmount (clearing.difference) }}</td>
                </tr>
            </tbody>  
        </v-simple-table>  
        <div v-else class="mt-10" style="display:flex; flex-direction: row; justify-content: center;">No data found</div>
      </v-card>  
    </v-container>
    </v-main>
    <clearing_details ref="clearing_details"></clearing_details>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>

import navBar from "@/components/ui/navbars/navbar.vue";
import date_picker from '@/components/ui/date_picker.vue';
import clearing_details from "@/views/task/fin/paynl/clearing_details.vue";

 export default {
  components: {
    navBar,
    date_picker,
    clearing_details
  },
  data() {
    return {
      hsabFromDate: null, 
      hsabUntilDate: null,
      loading: false,
      clearings: []
    }
  },
  mounted() {
    this.hsabFromDate = new Date(new Date().setDate(new Date().getDate() - 180)).toISOString().split('T')[0];
    this.hsabUntilDate = new Date().toISOString().split('T')[0];
  },
  methods: {
    formatAmount(amount) {
      let xamount = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount).replace('€', '');
      if(amount === 0) {
        return '';
      } else return xamount;
    },
    updateData(data){
      this[data.field] = data.value;
    },      
    openDetail(id, amount){
      this.$refs.clearing_details.open(id, amount)
    },
    getData() {
        this.loading = true;
        this.$axios
        .post("ares/json/ares/task/fin/paynl/getPncl.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getClearings"
          },
          getClearings: {
            datefrom: this.hsabFromDate,
            dateuntil: this.hsabUntilDate
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.loading = false;
          } else {
            this.clearings = res.data.getClearings;
            this.loading = false;
          }
        })
    },
  }
};

</script>

<style scoped>
.color {
    background-color: #faf8f8;
}
</style>